import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import RetefInfo from "../components/RetefInfo";
import Services from "../components/Services";
import Products from "../components/Products";
import Sectors from "../components/Sectors";
import Advantages from "../components/Advantages";
import Process from "../components/Process";
import Comparison from "../components/Comparison";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";

export default function Home() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <About />
        <RetefInfo />
        <Services />
        <Products />
        <Sectors />
        <Advantages />
        <Process />
        <Comparison />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}
